import React from 'react';
import { PALMESUS_FONT } from '../../lib/palmesusBrand';

interface Props {
  children: React.ReactNode;
}

/**
 * Wrapper som laster Poppins (Gilmer-erstatning) fra Google Fonts.
 * Bakgrunn settes av barna (FollowGate / SongRequestForm / Poster).
 */
export const PalmesusLayout: React.FC<Props> = ({ children }) => {
  return (
    <>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800;900&display=swap"
      />
      <div
        style={{
          fontFamily: PALMESUS_FONT,
          WebkitFontSmoothing: 'antialiased',
          backgroundColor: '#FF008C',
        }}
      >
        {children}
      </div>
    </>
  );
};
